import axios from 'axios';
import moment from 'moment';
import {errorHandler} from "./libs/lib.js";

const baseurl = 'disbursement';
const addKeys = ['tgl1','tgl2','partnerTransactionId','loan_id'];
export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keysDef = ['page', 'limit', 'sortBy', 'sortDir'];
                const keys = keysDef.concat(addKeys);
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                obj.loan_amount = meta.loan_amount;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    listV2(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keysDef = ['page', 'limit', 'sortBy', 'sortDir'];
                const addKeys2 = ['tgl1','partnerTransactionId','loan_id','typeDate','statusDisbursement'];
                const keys = keysDef.concat(addKeys2);
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/v2${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                obj.loan_amount = meta.loan_amount;
                obj.upfont_lender_amount = meta.upfont_lender_amount;
                obj.upfont_other_amount = meta.upfont_other_amount;
                obj.net_disbursement = meta.net_disbursement;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `disbursement_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxlsV2(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1','partnerTransactionId','loan_id','typeDate','statusDisbursement'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/v2${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `disbursement_${moment(obj.tgl1).format('YYYYMMDD')}_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    report(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keysDef = ['page', 'limit', 'sortBy', 'sortDir','pjxkey'];
                const keys = keysDef.concat(addKeys);
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/report${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                for (const key in meta) {
                    obj[key]=meta[key];
                }
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportreportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/export-report-xls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `disbursement_report_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(nasabahkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail/${nasabahkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    // UPLOAD SECTION
    importdtxls(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`${baseurl}/import-data-xlsx`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    reprocessDataUpload(obj){
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/reprocess-data-upload`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    reprocessDataUploadByFilename({filename,pjxkey}){
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/reprocess-data-upload-by-filename`, {filename,pjxkey});
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    posting(obj){
        return new Promise(async (resolve, reject) => {
            try {
                let {data} = await axios.post(`${baseurl}/posting`, obj);
                console.log('data',data);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    }

}